export enum PaymentPlanStateEnum {
  Cancelled,
  Active,
  InProgress,
  Completed
}

export enum PaymentPlanScheduleTypeEnum {
  Unknown,
  DownPayment,
  NextInstallment,
  SpecialInstallment
}

export enum PaymentPlanAmountTypeEnum {
  FixedAmount = 1,
  Percentage
}

export enum PaymentPlanScheduleDateTypeEnum {
  ExFactory = 1,
  SignOff,
  Manual
}
